import { v4 as uuidv4 } from 'uuid';
import {
  officePhoneForbornePricing as pricing,
  officePhoneNonForbornePricing as pricingNonForborne
} from '../../../utils/rates';
import {
  officePhoneFieldValues,
  twoMonthsDurationLabel
} from '../../../utils/constant';

export default ({ forbearance, officePhoneData }) => {
  const product = {
    lines: [],
    totalMonthly: 0,
    totalOneTime: 0
  };
  let totalMontlyMain = 0;
  if (officePhoneData && officePhoneData.length) {
    if (officePhoneData) {
      officePhoneData.forEach(
        ({
          type,
          ratePlan,
          term,
          regularOfferOfficePhone,
          limitedTimeOfferOfficePhone,
          pricingAndOffers,
          twoMonthsDuration,
          ovLines,
          forbearance
        }) => {
          let subTotal = 0;
          const line = {
            type: type.value,
            ratePlan: {
              value: ratePlan.value,
              qty: 1,
              prices: {
                monthly: 0,
                oneTime: 0
              }
            },
            regularOffers: [],
            limitedTimeOffers: []
          };
          if (forbearance.value === officePhoneFieldValues.forbearance.forborne) {
            line.ratePlan.prices.monthly = pricing[ratePlan.value][term.value];
            subTotal += pricing[ratePlan.value][term.value];

            if (twoMonthsDuration && twoMonthsDuration.value === 'Yes') {
              const deduction = pricing[ratePlan.value][term.value];
              line.regularOffers.push({
                key: uuidv4(),
                value: twoMonthsDurationLabel,
                qty: 1,
                prices: {
                  monthly: -deduction,
                  oneTime: 0
                }
              });
              subTotal -= deduction;
            }
            if (limitedTimeOfferOfficePhone) {
              const deduction = pricing[ratePlan.value][term.value];
              line.limitedTimeOffers.push({
                key: uuidv4(),
                value: limitedTimeOfferOfficePhone.value,
                qty: 1,
                prices: {
                  monthly: -deduction,
                  oneTime: 0
                }
              });
              subTotal -= deduction;
            }
            if (regularOfferOfficePhone) {
              const deduction =
                pricing[ratePlan.value][regularOfferOfficePhone.value];
              line.regularOffers.push({
                key: uuidv4(),
                value: regularOfferOfficePhone.value,
                qty: 1,
                prices: {
                  monthly: deduction,
                  oneTime: 0
                }
              });
              subTotal += deduction;
            }
          } else {
            line.ratePlan.prices.monthly =
              pricingNonForborne[ratePlan.value].price;
            subTotal += pricingNonForborne[ratePlan.value].price;

            if (pricingAndOffers) {
              const pricingOfferPrice =
                pricingNonForborne[ratePlan.value][pricingAndOffers.value];
              if (pricingOfferPrice) {
                line.regularOffers.push({
                  key: uuidv4(),
                  value: pricingAndOffers.value,
                  qty: 1,
                  prices: {
                    monthly: pricingOfferPrice,
                    oneTime: 0
                  }
                });
                subTotal += pricingOfferPrice;
              }
            }
          }
          line.totalMonthly = subTotal;
          totalMontlyMain += subTotal > 0 ? subTotal : 0;
          line.totalOneTime = 0;
          line.key = uuidv4();
          product.lines.push(line);

          ovLines.forEach(
            ({
              type: typeOv,
              ratePlan: ratePlanOv,
              term: termOv,
              regularOfferOfficePhone: regularOfferOfficePhoneOv,
              pricingAndOffers: pricingAndOffersOv,
              twoMonthsDuration: twoMonthsDurationOv,
              limitedTimeOfferOfficePhone: limitedTimeOfferOfficePhoneOv,
              forbearance
            }) => {
              const lineOv = {
                type: typeOv.value,
                ratePlan: {
                  value: ratePlan.value,
                  qty: 1,
                  prices: {
                    monthly: 0,
                    oneTime: 0
                  }
                },
                regularOffers: [],
                limitedTimeOffers: []
              };
              let subTotalOv = 0;

              if (forbearance.value === officePhoneFieldValues.forbearance.forborne) {
                lineOv.ratePlan.prices.monthly =
                  pricing[ratePlanOv.value][termOv.value];
                subTotalOv += pricing[ratePlanOv.value][termOv.value];

                if (
                  twoMonthsDurationOv &&
                  twoMonthsDurationOv.value === 'Yes'
                ) {
                  const deduction = pricing[ratePlanOv.value][termOv.value];
                  lineOv.regularOffers.push({
                    key: uuidv4(),
                    value: twoMonthsDurationLabel,
                    qty: 1,
                    prices: {
                      monthly: -deduction,
                      oneTime: 0
                    }
                  });
                  subTotalOv -= deduction;
                } else if (limitedTimeOfferOfficePhoneOv) {
                  const deduction = pricing[ratePlanOv.value][termOv.value];
                  lineOv.limitedTimeOffers.push({
                    key: uuidv4(),
                    value: limitedTimeOfferOfficePhoneOv.value,
                    qty: 1,
                    prices: {
                      monthly: -deduction,
                      oneTime: 0
                    }
                  });
                  subTotalOv -= deduction;
                } else if (regularOfferOfficePhoneOv) {
                  const deduction =
                    pricing[ratePlanOv.value][regularOfferOfficePhoneOv.value];
                  lineOv.regularOffers.push({
                    key: uuidv4(),
                    value: regularOfferOfficePhoneOv.value,
                    qty: 1,
                    prices: {
                      monthly: deduction,
                      oneTime: 0
                    }
                  });
                  subTotalOv += deduction;
                }
              } else {
                lineOv.ratePlan.prices.monthly =
                  pricingNonForborne[ratePlanOv.value].price;
                subTotalOv += pricingNonForborne[ratePlanOv.value].price;
                if (pricingAndOffersOv) {
                  const pricingOfferPrice =
                    pricingNonForborne[ratePlanOv.value][
                    pricingAndOffersOv.value
                    ];
                  if (pricingOfferPrice) {
                    lineOv.regularOffers.push({
                      key: uuidv4(),
                      value: pricingAndOffersOv.value,
                      qty: 1,
                      prices: {
                        monthly: pricingOfferPrice,
                        oneTime: 0
                      }
                    });
                    subTotalOv += pricingOfferPrice;
                  }
                }

              }

              lineOv.totalMonthly = subTotalOv;
              totalMontlyMain += subTotalOv > 0 ? subTotalOv : 0;
              lineOv.totalOneTime = 0;
              lineOv.key = uuidv4();
              product.lines.push(lineOv);
            }
          );
        }
      );
    }
  }

  product.totalMonthly = totalMontlyMain;

  return product;
};
